import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col } from 'react-bootstrap';
import { useI18n, formatDate } from '../../i18n/i18n';
import { API_BASE } from '../../config';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const LatestNewsPart = () => {
    const [latestBlogs, setLatestBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, locale } = useI18n();

    useEffect(() => {
        // 加载最新的博客数据
        fetch(`${API_BASE}/api/blogs`)
            .then(response => response.json())
            .then(data => {
                const mapped = data.map(b => ({ ...b, folderName: b.folder_name }));
                const sortedBlogs = mapped.sort((a, b) => new Date(b.date) - new Date(a.date));
                setLatestBlogs(sortedBlogs.slice(0, 3));
            })
            .catch(error => console.error('Error loading blog list:', error))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="latest-news-area gray-bg">
            <Container>
                <Row className="justify-content-center">
                    <Col lg="6">
                        <div className="section-title text-center">
                            <span>{t('home.news.subtitle', 'latest news')}</span>
                            <h2 className="title">{t('home.news.title', '新闻中心')}</h2>
                        </div>
                    </Col>
                </Row>
            </Container>

            <div className="letast-news-grid white-bg ml-40 mr-40">
                <Container>
                    <Row>
                        <Col lg="12">
                            <div className="latest-news">
                                <Row>
                                    {loading ? <LoadingSpinner text={t('common.loading')} height="200px" /> : latestBlogs.map((blog, index) => (
                                        <div
                                            className="col-lg-4 col-md-6"
                                            key={index}
                                        >
                                            <div className="letest-news-item mt-30" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                <div>
                                                    <span>{formatDate(blog.date, locale)}</span>
                                                    <h4 className="title">
                                                        <Link to={`/blog-details/${blog.folderName}`}>
                                                            {blog.title}
                                                        </Link>
                                                    </h4>
                                                    <p>{blog.description}</p>
                                                </div>
                                                <div style={{ marginTop: 'auto' }}>
                                                    <Link to={`/blog-details/${blog.folderName}`} className="main-btn">
                                                        {t('home.news.cta', '了解更多')}
                                                        <FontAwesomeIcon icon={faLongArrowAltRight} className="pl-1" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default LatestNewsPart;